import React from 'react';

import { Segmented } from 'antd';

import { useStatementContext } from '../StatementContext';

/**
 * PayableFilters
 *
 * Filter controls for payable statements (client status, payment status, invoice status)
 */
const PayableFilters = ({ onUpdateClientStatus, onUpdatePaymentStatus, onUpdateInvoiceStatus }) => {
    const { contactType, filters } = useStatementContext();

    return (
        <div className="statement-filters">
            <div className="statement-filter">
                <small>client status</small>
                <Segmented
                    value={filters.clientStatus}
                    onChange={onUpdateClientStatus}
                    size="small"
                    options={[
                        { label: 'Invoiced', value: 'Invoiced' },
                        { label: 'Not Paid', value: 'NotPaid' },
                        { label: 'Paid', value: 'Paid' },
                    ]}
                />
            </div>
            <div className="statement-filter">
                <small>{contactType} payment</small>
                <Segmented
                    value={filters.paymentStatus}
                    onChange={onUpdatePaymentStatus}
                    size="small"
                    options={[
                        { label: 'All', value: 'All' },
                        { label: 'Not Paid', value: 'NotPaid' },
                        { label: 'Paid', value: 'Paid' },
                    ]}
                />
            </div>
            {contactType === 'model' && (
                <div className="statement-filter">
                    <small>{contactType} invoice</small>
                    <Segmented
                        value={filters.invoiceStatus}
                        onChange={onUpdateInvoiceStatus}
                        size="small"
                        options={[
                            { label: 'All', value: 'All' },
                            { label: 'Not Invoiced', value: 'NotInvoiced' },
                            { label: 'Invoiced', value: 'Invoiced' },
                        ]}
                    />
                </div>
            )}
        </div>
    );
};

export default PayableFilters;
